@if (loaded()) {
  <div id="coverage">
    <hyperkit-typography
      class="coverage-title"
      variant="h4"
      align="left"
      color="primary"
      >Coverage</hyperkit-typography
    >
    <!-- Top MITRE -->
    <div class="coverage-section">
      <div class="coverage-chart">
        <hyperkit-typography variant="h5" align="left" color="primary"
          >Top MITRE</hyperkit-typography
        >
        <div id="top-mitre-container" class="chart-container"></div>
      </div>
      @if (huntMITRECoverage?.length > 0) {
        <div class="coverage-table-wrapper">
          <table class="coverage-table">
            <thead>
              <tr>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Technique</hyperkit-typography
                  >
                </th>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Tactic</hyperkit-typography
                  >
                </th>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Packages</hyperkit-typography
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              @for (mitre of huntMITRECoverage; track mitre) {
                <tr>
                  <td>
                    <hyperkit-link
                      variant="emphasized"
                      size="sm"
                      href="https://attack.mitre.org/techniques/{{
                        mitre.name.replace('.', '/')
                      }}"
                      target="_blank"
                      align="left"
                      color="primary"
                      text="{{ mitre?.name }}"
                    ></hyperkit-link>
                  </td>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ mitre?.category }}</hyperkit-typography
                    >
                  </td>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ mitre?.huntPackageCount }}</hyperkit-typography
                    >
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    <!-- Top Actors -->
    <div class="coverage-section new-page">
      <div class="coverage-chart">
        <hyperkit-typography variant="h5" align="left" color="primary"
          >Top Actors</hyperkit-typography
        >
        <div id="top-actors-container" class="chart-container"></div>
      </div>
      <div class="coverage-table-wrapper">
        @if (huntActorCoverage?.length > 0) {
          <table class="coverage-table">
            <thead>
              <tr>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Name</hyperkit-typography
                  >
                </th>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Origin</hyperkit-typography
                  >
                </th>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Packages</hyperkit-typography
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              @for (actor of huntActorCoverage; track actor) {
                <tr>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ actor?.name }}</hyperkit-typography
                    >
                  </td>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ actor?.category }}</hyperkit-typography
                    >
                  </td>
                  <td class="link">
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ actor?.huntPackageCount }}</hyperkit-typography
                    >
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
    <!-- Top Threats -->
    <div class="coverage-section new-page">
      <div class="coverage-chart">
        <hyperkit-typography variant="h5" align="left" color="primary"
          >Top Threats</hyperkit-typography
        >
        <div id="top-threats-container" class="chart-container"></div>
      </div>
      <div class="coverage-table-wrapper">
        @if (huntThreatCoverage?.length > 0) {
          <table class="coverage-table">
            <thead>
              <tr>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Name</hyperkit-typography
                  >
                </th>
                <th>
                  <hyperkit-typography
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >Packages</hyperkit-typography
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              @for (threat of huntThreatCoverage; track threat) {
                <tr>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ threat.name }}</hyperkit-typography
                    >
                  </td>
                  <td>
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="body"
                      >{{ threat.huntPackageCount }}</hyperkit-typography
                    >
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  </div>
} @else {
  <p>Loading…</p>
}
